import {DashboardTileCoordinates} from '../types/DashboardTileCoordinates';

// Droppable id of a free board place; parseDashboardGapSlotId reads it back.
export const toDashboardGapSlotId = (coordinates: DashboardTileCoordinates) =>
  `gap:${coordinates.column}:${coordinates.row}`;
